<template>
    <ClientOnly>
        <VueApexCharts :width="width || '100%'" :ref="chartRef || 'apexchart'" :height="height" :type="type" :options="options" :series="series" />
    </ClientOnly>
</template>
<script>
import VueApexCharts from "vue3-apexcharts";
export default {
    props: ['width', 'height', 'type', 'options', 'series', 'chartRef'],
    components: {
        VueApexCharts
    }
}
</script>